import { createWebHistory, createRouter, RouteRecordRaw } from "vue-router";
import Views from '../views';
const {
    CatalogoView,
    LoginView,
    WelcomeView,
    PedidoView,
    NotFoundView,
    EmailBookView,
    BrandEmailBookView,
    UserEmailBookView,
    PedidoListView,
    CatalogoConfigView,
    ProfileView,
    UserInfoView,
    TransitoLabListView,
    PermisosView,
    PedidoPlantillasView
} = Views;

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        component: LoginView,
    },
    {
        path: "/inicio",
        component: WelcomeView,
    },
    {
        path: "/catalogo",
        component: CatalogoView,
    },
    {
        path: "/catalogo/config",
        component: CatalogoConfigView,
    },
    {
        path: "/pedido",
        component: PedidoView,
    },
    {
        path: "/agenda",
        component: EmailBookView,
    },
    {
        name: 'agenda-marcas',
        path: "/agenda/marcas",
        component: BrandEmailBookView,
    },
    {
        name: 'agenda-empresa',
        path: "/agenda/empresa",
        component: UserEmailBookView,
    },
    {
        path: "/lista-pedidos",
        component: PedidoListView,
    },
    {
        path: "/perfil",
        component: ProfileView,
    },
    {
        path: "/informacion-usuario",
        component: UserInfoView,
    },
    {
        path: "/transito",
        component: TransitoLabListView,
    },
    {
        path: "/permisos",
        component: PermisosView,
    },
    {
        path: "/pedido-plantillas",
        component: PedidoPlantillasView,
    },
    {
        path: "/page-not-found",
        component: NotFoundView,
    },
    { path: "/:pathMatch(.*)*", redirect: "/page-not-found" },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: routes,
    linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
    // Si NO está autenticado y no va al login, lo mandas a login
    if (!isAuthenticated() && to.path !== "/") {
        next("/");
    }
    // Si SÍ está autenticado y va a login, lo mandas a inicio
    else if (isAuthenticated() && to.path === "/") {
        next("/inicio");
    }
    // Si está autenticado y va a cualquier otro lado, continúa normal
    else {
        next();
    }
});

// Función para validar autenticación (ajusta según tu lógica)
function isAuthenticated() {
    // Ejemplo usando localStorage
    return !!localStorage.getItem('authToken');
}

export default router;
